import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { from } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { FirebaseRemoteConfigService } from '../services/firebase/firebase-remote-config/firebase-remote-config.service';
import { LoggingService } from '@app/core/services/logging/logging.service';

export const remoteConfigGuard: CanActivateFn = (route) => {
  const remoteConfigService = inject(FirebaseRemoteConfigService);
  const router = inject(Router);
  const configKey = route.data['remoteConfigKey'];

  if (!configKey) {
    LoggingService.error('No remote config key provided in route data');
    return false;
  }

  return from(remoteConfigService.getBoolean({ key: configKey })).pipe(
    take(1),
    map((result) => {
      if (!result.value) {
        LoggingService.log(`Feature ${configKey} is disabled`);
        router.navigate(['/']);
        return false;
      }
      return true;
    }),
  );
};
